/* ------------------------------------------------------------------ */
/*  Lumao lightbox - lightweight image preview for content sections.   */
/*  Dependency-free. Activates on any element carrying [data-lm-zoom]   */
/*  or the .lm-zoomable class. Opens a fullscreen overlay with the      */
/*  full-size image, click-to-zoom + pan, and keyboard / backdrop close.*/
/* ------------------------------------------------------------------ */
(function () {
  const TRIGGER_SELECTOR = '[data-lm-zoom], .lm-zoomable';

  let overlay = null;
  let dialogImg = null;
  let captionEl = null;
  let lastFocused = null;
  let zoomed = false;

  // Pick the highest-resolution source available for an <img>.
  function largestSrc(img) {
    if (!img) return null;
    if (img.dataset.lmZoom) return img.dataset.lmZoom;
    const srcset = img.getAttribute('srcset');
    if (srcset) {
      let best = null;
      let bestW = 0;
      srcset.split(',').forEach((part) => {
        const [url, w] = part.trim().split(/\s+/);
        const width = w ? parseInt(w, 10) : 0;
        if (url && width >= bestW) {
          bestW = width;
          best = url;
        }
      });
      if (best) return best;
    }
    return img.currentSrc || img.src || null;
  }

  // Resolve {src, caption} from a clicked trigger element.
  function resolveTrigger(trigger) {
    let src = trigger.getAttribute('data-lm-zoom');
    let img = trigger.matches('img') ? trigger : trigger.querySelector('img');
    if (!img) {
      const figure = trigger.closest('figure, .lm-photo, .hero-split__media-frame');
      if (figure) img = figure.querySelector('img');
    }
    if (!src) src = largestSrc(img);

    let caption = trigger.getAttribute('data-lm-zoom-caption');
    if (!caption && img) caption = img.getAttribute('alt');
    if (!caption) {
      const fig = trigger.closest('figure, .lm-photo');
      const cap = fig && fig.querySelector('figcaption, .lm-photo__caption');
      if (cap) caption = cap.textContent.trim();
    }
    return { src, caption };
  }

  function buildOverlay() {
    overlay = document.createElement('div');
    overlay.className = 'lm-lightbox';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'Náhled obrázku');
    overlay.innerHTML = `
      <button type="button" class="lm-lightbox__close" aria-label="Zavřít náhled">
        <svg viewBox="0 0 24 24" width="22" height="22" fill="none" aria-hidden="true">
          <path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
        </svg>
      </button>
      <figure class="lm-lightbox__figure">
        <img class="lm-lightbox__img" alt="">
        <figcaption class="lm-lightbox__caption"></figcaption>
      </figure>
    `;
    dialogImg = overlay.querySelector('.lm-lightbox__img');
    captionEl = overlay.querySelector('.lm-lightbox__caption');

    overlay.addEventListener('click', (e) => {
      if (e.target === overlay || e.target.closest('.lm-lightbox__close')) close();
    });
    dialogImg.addEventListener('click', (e) => {
      e.stopPropagation();
      toggleZoom(e);
    });
    dialogImg.addEventListener('mousemove', panZoom);
    document.body.appendChild(overlay);
  }

  function toggleZoom(e) {
    zoomed = !zoomed;
    overlay.classList.toggle('is-zoomed', zoomed);
    if (zoomed) panZoom(e);
    else dialogImg.style.transformOrigin = '';
  }

  function panZoom(e) {
    if (!zoomed) return;
    const rect = dialogImg.getBoundingClientRect();
    const x = ((e.clientX - rect.left) / rect.width) * 100;
    const y = ((e.clientY - rect.top) / rect.height) * 100;
    dialogImg.style.transformOrigin = `${x}% ${y}%`;
  }

  function open(src, caption) {
    if (!src) return;
    if (!overlay) buildOverlay();
    lastFocused = document.activeElement;
    zoomed = false;
    overlay.classList.remove('is-zoomed');
    dialogImg.style.transformOrigin = '';
    dialogImg.src = src;
    dialogImg.alt = caption || '';
    captionEl.textContent = caption || '';
    captionEl.hidden = !caption;

    document.documentElement.classList.add('lm-lightbox-open');
    // Force reflow so the open transition runs.
    void overlay.offsetWidth;
    overlay.classList.add('is-open');
    overlay.querySelector('.lm-lightbox__close').focus();
    document.addEventListener('keydown', onKeydown);
  }

  function close() {
    if (!overlay) return;
    overlay.classList.remove('is-open', 'is-zoomed');
    zoomed = false;
    document.documentElement.classList.remove('lm-lightbox-open');
    document.removeEventListener('keydown', onKeydown);
    if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
  }

  function onKeydown(e) {
    if (e.key === 'Escape') close();
  }

  document.addEventListener('click', (e) => {
    const trigger = e.target.closest(TRIGGER_SELECTOR);
    if (!trigger) return;
    const { src, caption } = resolveTrigger(trigger);
    if (!src) return;
    e.preventDefault();
    open(src, caption);
  });
})();
